// extracted by mini-css-extract-plugin
export default {"form":"SignupDialog_form__pPN4H","intro":"SignupDialog_intro__u56x1","field":"SignupDialog_field__mLhrs","error":"SignupDialog_error__l3rV4"};